export function setTimeToDate(date: Date, minutes: number): Date {
  const totalHours = minutes / 60;
  const totalMinutes = minutes % 60;
  return new Date(
    new Date(new Date(date).setHours(totalHours)).setMinutes(totalMinutes)
  );
}
